/* eslint-disable */

import React, { useMemo } from 'react'
import { withStyles } from '@aura/components/styles'
import { Box, Button, Grid } from '@aura/components'
import PropTypes from 'prop-types'
import styles from './styles'
import RegistrationContainer from '../../../../components/new-registration-container'
import { useTranslation } from 'react-i18next'


const Component = ({
    classes,
    data,
    factorType,
    isBackAllowed,
    onBack,
    onNext,
    title,
    verbiage
}) => {

    const { t: translate } = useTranslation()
    const subTitle = {
        'gotp': translate('mfaEnrollment.notScanGotp'),
        'opush': translate('mfaEnrollment.notScanOpush'),
        'ootp': translate('mfaEnrollment.notScanOotp')
    }

    const { sharedSecret } = data
    const stepTitle = translate('cantScanQRCode')

           const footerContent = useMemo(() => {
                const footerButtons = [
                    {
                        className: classes.backButton,
                        label: translate('back'),
                        onClick: onBack
                    },
                    {
                        className: `${classes.nextButton}`,
                        label: translate('next'),
                        onClick: onNext
                    }
                ]
                
                return (
                    <Grid className={classes.buttonContainer}>
                        {footerButtons.map((button, index) => (
                            <Button
                                key={`footer-button-${index}`}
                                className={button.className}
                                color='primary'
                                disabled={button.disabled}
                                onClick={button.onClick}
                            >
                                {button.label}
                            </Button>
                        ))}
                    </Grid>
                )
            }, [classes.buttonContainer, classes.cancelButton, classes.nextButton, classes.backButton, translate, onBack, onNext])
            

        const mainContent = useMemo(() => (
                <>
                    <div className={classes.container}>
                        <>
                            <div className={classes.introText}>
                                <p className={classes.subTitle}>{stepTitle}</p>
                    <p className={classes.subTitle}>{subTitle[factorType]}</p>
                </div>
                <Box className={classes.secret}>{sharedSecret}</Box>
                            </> 
                        <div className={classes.contentDivider}></div>            
                    </div>
                    
                    <div className={classes.helpText}>
                        <p className={classes.subTitle}>{translate('registrationFlow.helpText')}</p>
                    </div>
                </>
            ), [classes, translate, factorType, data])
        

    return (
        <RegistrationContainer {...{ title: translate(`authenticatorOptions.${title}`), verbiage: translate(`authenticatorOptions.${verbiage}`), footerActions : footerContent, mainContent }}>
        </RegistrationContainer>
    )
}

Component.displayName = 'QRCodeCannotScan'

Component.defaultProps = {
    isBackAllowed: true
}


Component.propTypes = {
    classes: PropTypes.shape({
        button: PropTypes.object,
        loader: PropTypes.object,
        root: PropTypes.object,
        stepper: PropTypes.object,
        stepperContainer: PropTypes.object
    }),
    data: PropTypes.object,
    isBackAllowed: PropTypes.bool.isRequired,
    onBack: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    verbiage: PropTypes.string
}

export default withStyles(Component, styles)
